'use client';

/**
 * Skeleton placeholder for `TransactionRow`. Same overall shell so the
 * swap to real rows is jank-free. Three of these stack on the initial
 * fetch in `TransactionsScreen` (replaces the M2-era `Carregando...` text).
 */
export function TransactionRowSkeleton() {
  return (
    <div className="flex w-full items-center gap-3 px-4 py-3" aria-hidden>
      <span className="animate-pulse-slow size-11 shrink-0 rounded-2xl bg-surface-sunken" />
      <div className="min-w-0 flex-1 space-y-2">
        <div className="animate-pulse-slow h-3 w-2/5 rounded bg-surface-sunken" />
        <div className="animate-pulse-slow h-2.5 w-1/3 rounded bg-surface-sunken" />
      </div>
      <div className="animate-pulse-slow h-3 w-16 shrink-0 rounded bg-surface-sunken" />
    </div>
  );
}
